<template>
    <div class="offerDetail">
        <h1>
            Oferta {{ offer.num_oferty }}
            <span v-if="offer.transakcja == 's'">({{ offer.nazwa }} - Sprzedaż)</span>
            <span v-else>({{ offer.nazwa }} - Wynajem)</span>
            <router-link class="close" :to="`${pagePrevious}`">
                <svg width="32px" height="32px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="4,4 44,44" fill="none" stroke-width="5" stroke="black" stroke-linecap="round"/>
                    <polyline points="4,44 44,4" fill="none" stroke-width="5" stroke="black" stroke-linecap="round"/>
                </svg>
            </router-link>
        </h1>
        <div class="detailsContainer">
            <div class="details">
                <div class="leftSide">
                    <div
                        class="main"
                        :class="{ active: isActive }"
                        @click="zoomImage"
                    >
                        <div
                            class="zoom"
                            :style="{ backgroundImage: `url(/assets/img/offer/${offer.zdjecie_glowne})` }"
                        ><img :src="`/assets/img/offer/${offer.zdjecie_glowne}`" :alt="`${offer.zdjecie_glowne}`"></div>
                    </div>
                    <div class="rest">
                        <div class="restPhoto" v-for="zdjecie in offer.zdjecia" :key="zdjecie">
                            <div
                                :style="{ backgroundImage: `url(/assets/img/offer/${zdjecie})` }"
                                @click="offer.zdjecie_glowne = zdjecie"
                            />
                        </div>
                    </div>
                </div>
                <div class="rightSide">
                    <div v-if="offer.typ_karty=='dom'">
                        <h2>INFORMACJE PODSTAWOWE</h2>
                        <div class="info">Cena:<span>{{ offer.cena }} PLN</span></div>
                        <div class="info">Obiekt:<span>{{ offer.obiekt_nazwa }}</span></div>
                        <div class="info">Rodzaj obiektu:<span>{{ offer.obiekt_rodzaj }}</span></div>
                        <div class="info">Miasto/gmina:<span>{{ offer.pole_2 }}</span></div>
                        <div class="info">Dzielnica/miasteczko:<span>{{ offer.dzielnica }}</span></div>
                        <div class="info">Ulica:<span>{{ offer.ulica }}</span></div>
                        <div class="info">Ilość kondygnacji:<span>{{ offer.pole_8 }}</span></div>
                        <div class="info">Budulec:<span>{{ offer.pole_10 }}</span></div>
                        <div class="info">Powierzchnia całkowita:<span>{{ offer.powierzchnia }}</span></div>
                        <div class="info">Powierzchnia użytkowa:<span>{{ offer.pole_4 }}</span></div>
                        <div class="info">Stropy:<span>{{ offer.pole_1 }}</span></div>
                        <div class="info">Podpiwniczenie:<span>{{ offer.pole_20 }}</span></div>
                        <div class="info">Typ dachu:<span>{{ offer.pole_24 }}</span></div>
                        <div class="info">Ogrzewanie:<span>{{ offer.pole_22 }}</span></div>
                        <div class="info">Pow. działki:<span>{{ offer.pole_5 }}</span></div>
                        <h2>INFORMACJE DODATKOWE</h2>
                        <div class="info">Kanalizacja:<span>{{ offer.pole_21 }}</span></div>
                        <div class="info">Garaż:<span>{{ offer.pole_9 }}</span></div>
                    </div>
                    <div v-if="offer.typ_karty=='mieszkanie'">
                        <h2>INFORMACJE PODSTAWOWE</h2>
                        <div class="info">Cena:<span>{{ offer.cena }} PLN</span></div>
                        <div class="info">Rodzaj budynku:<span>{{ offer.obiekt_rodzaj }}</span></div>
                        <div class="info">Miasto/gmina:<span>{{ offer.pole_2 }}</span></div>
                        <div class="info">Dzielnica/miasteczko:<span>{{ offer.dzielnica }}</span></div>
                        <div class="info">Ulica:<span>{{ offer.ulica }}</span></div>
                        <div class="info">Forma własności:<span>{{ offer.pole_12 }}</span></div>
                        <div class="info">Powierzchnia:<span>{{ offer.powierzchnia }}m&sup2;</span></div>
                        <div class="info">Piętro:<span>{{ offer.pole_1 }}</span></div>
                        <div class="info">Balkon:<span>{{ offer.pole_4 }}</span></div>
                        <div class="info">Okna:<span>{{ offer.pole_16 }}</span></div>
                        <div class="info">Ogrzewanie:<span>{{ offer.pole_6 }}</span></div>
                        <div class="info">Opomiarowanie:<span>{{ offer.pole_8 }}</span></div>
                        <div class="info">Czynsz:<span>{{ offer.pole_20 }}</span></div>
                        <div class="info">Standard:<span>{{ offer.pole_23 }}</span></div>
                        <h2>INFORMACJE DODATKOWE</h2>
                        <div class="info">Podłogi - pokoje:<span>{{ offer.pole_21 }}</span></div>
                        <div class="info">Kuchnia:<span>{{ offer.pole_9 }}</span></div>
                        <div class="info">Łazienka:<span>{{ offer.pole_13 }}</span></div>
                        <div class="info">WC:<span>{{ offer.pole_15 }}</span></div>
                        <div class="info">Dodatkowe media:<span>{{ offer.pole_19 }}</span></div>
                    </div>
                    <div v-if="offer.typ_karty=='lokal'">
                        <h2>INFORMACJE PODSTAWOWE</h2>
                        <div class="info">Cena:<span>{{ offer.cena }} PLN</span></div>
                        <div class="info">Rodzaj lokalu:<span>{{ offer.obiekt_rodzaj }}</span></div>
                        <div class="info">Miasto/gmina:<span>{{ offer.pole_2 }}</span></div>
                        <div class="info">Dzielnica/miasteczko:<span>{{ offer.dzielnica }}</span></div>
                        <div class="info">Ulica:<span>{{ offer.ulica }}</span></div>
                        <div class="info">Powierzchnia dzialki:<span>{{ offer.pole_1 }} m&sup2;</span></div>
                        <div class="info">Powierzchnia:<span>{{ offer.powierzchnia }} m&sup2;</span></div>
                        <div class="info">Wysokość pomieszczen:<span>{{ offer.pole_8 }}</span></div>
                        <div class="info">Umiejscowienie obiektu:<span>{{ offer.pole_3 }}</span></div>
                        <div class="info">Dojazd:<span>{{ offer.pole_10 }}</span></div>
                        <div class="info">Ogrzewanie:<span>{{ offer.pole_11 }}</span></div>
                        <div class="info">Media technologiczne:<span>{{ offer.pole_9 }}</span></div>
                        <div class="info">Instalacje:<span>{{ offer.pole_20 }}</span></div>
                        <div class="info">Mozliwe przeznaczenie:<span>{{ offer.pole_4 }}</span></div>
                    </div>
                    <div v-if="offer.typ_karty=='dzialka'">
                        <h2>INFORMACJE PODSTAWOWE</h2>
                        <div class="info">Cena:<span>{{ offer.cena }} PLN</span></div>
                        <div class="info">Rodzaj działki:<span>{{ offer.obiekt_rodzaj }}</span></div>
                        <div class="info">Miasto/gmina:<span>{{ offer.pole_2 }}</span></div>
                        <div class="info">Dzielnica/miasteczko:<span>{{ offer.dzielnica }}</span></div>
                        <div class="info">Ulica:<span>{{ offer.ulica }}</span></div>
                        <div class="info">Powierzchnia:<span>{{ offer.powierzchnia }}m&sup2;</span></div>
                        <div class="info">Szerokość:<span>{{ offer.pole_5 }}m</span></div>
                        <div class="info">Dojazd:<span>{{ offer.pole_8 }}</span></div>
                        <div class="info">Ukształtowanie ter.:<span>{{ offer.pole_24 }}</span></div>
                        <div class="info">Okolice:<span>{{ offer.pole_6 }}</span></div>
                        <div class="info">Woda:<span>{{ offer.pole_10 }}</span></div>
                        <div class="info">Prąd:<span>{{ offer.pole_11 }}</span></div>
                        <div class="info">Gaz:<span>{{ offer.pole_14 }}</span></div>
                        <div class="info">Kanalizacja:<span>{{ offer.pole_15 }}</span></div>
                    </div>
                    <div v-if="offer.typ_karty=='obiekt'">
                        <h2>INFORMACJE PODSTAWOWE</h2>
                        <div class="info">Cena:<span>{{ offer.cena }} PLN</span></div>
                        <div class="info">Rodzaj budynku:<span>{{ offer.obiekt_rodzaj }}</span></div>
                        <div class="info">Miasto/gmina:<span>{{ offer.pole_2 }}</span></div>
                        <div class="info">Dzielnica/miasteczko:<span>{{ offer.dzielnica }}</span></div>
                        <div class="info">Ulica:<span>{{ offer.ulica }}</span></div>
                        <div class="info">Forma własności:<span>{{ offer.sql_pole_22 }}</span></div>
                        <div class="info">Lata budowy:<span>{{ offer.sql_pole_23 }}</span></div>
                        <div class="info">Powierzchnia:<span>{{ offer.sql_powierzchnia }}</span></div>
                        <div class="info">Powierzchnia działki.:<span>{{ offer.sql_pole_1 }}</span></div>
                        <div class="info">Standard:<span>{{ offer.sql_pole_24 }}</span></div>
                        <div class="info">Ilość kondygnacji:<span>{{ offer.sql_pole_21 }}</span></div>
                        <div class="info">Wysokość pomieszczeń:<span>{{ offer.sql_pole_8 }}</span></div>
                        <div class="info">Ogrzewanie:<span>{{ offer.sql_pole_11 }}</span></div>
                        <div class="info">Przeznaczenie:<span>{{ offer.sql_pole_4 }}</span></div>
                        <h2>INFORMACJE DODATKOWE</h2>
                        <div class="info">Zaplecze biurowe:<span>{{ offer.sql_pole_7 }}</span></div>
                        <div class="info">Zaplecze magazyn.:<span>{{ offer.sql_pole_6 }}</span></div>
                        <div class="info">Media technologiczne:<span>{{ offer.sql_pole_9 }}</span></div>
                        <div class="info">Suwnice:<span>{{ offer.sql_pole_25 }}</span></div>
                    </div>

                    <h2>OPIS</h2>
                    <div class="opis">{{ offer.opis }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OfferDetails",
    props: {},
    data () {
        return {
            offer: {},
            pagePrevious: null,
            isActive: false
        };
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.pagePrevious = (from.fullPath === '/') ? '/search/list/1' : from.fullPath;
        });
    },
    methods: {
        zoomImage () {
            this.isActive = ! this.isActive;
        }
    },
    async created () {
        try {
            let response = await fetch(process.env.VUE_APP_XHR, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        mode: 'details',
                        id: this.$route.params.id
                    })
                }
            )
            this.offer = (await response.json());
        } catch (err) {
            console.log(err)
        }
    }
}
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
    width: 8px;
    border-radius: 4px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;

    &:hover {
        background: #555;
    }
}

.offerDetail {
    position: relative;

    h1 {
        font: 32px/48px "Google Sans";
        margin: 0 20px;

        .close {
            position: absolute;
            top: 10px;
            right: 10px;
            text-transform: uppercase;
            text-decoration: none;
            color: #000000;

            &:hover:before {
                background-color: rgba(#000, .4);
            }

            &:before {
                content: "";
                width: 48px;
                height: 48px;
                display: block;
                border-radius: 24px;
                background-color: rgba(#000, .1);
                position: absolute;
                top: -6px;
                left: -8px;
                transition: background-color 300ms;
            }
        }
    }
}

h3 {
    font: 16px/24px "Google Sans";
    margin: 0 20px;
}


.detailsContainer {
    overflow-x: hidden;
    overflow-y: scroll;
    height: calc(90vh - 100px);
    margin-top: 20px;
}

.details {
    display: flex;

    > .leftSide {
        width: 440px;

        > .main {
            width: 400px;
            height: 300px;
            margin: 20px;
            transition: all 300ms;
            cursor: pointer;
            background-image: url("/assets/no-photo-available.png");
            background-size: contain;
            background-position: center;

            .zoom {
                border: solid 1px #666666;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                position: relative;
                padding: 0;
                width: 100%;
                min-height: 300px;

                transition: all 300ms;

                img {
                    margin: 0;
                    width: 400px;
                    height: 300px;
                    visibility: hidden;
                }
            }

            &.active .zoom {
                position: absolute;
                background-size: contain;
                background-color: rgba(#000, .6);
                backdrop-filter: blur(10px);
                top: 0;
                left: 0;
                margin: 0;
                z-index: 10;
                height: 100%;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }

        > .rest {
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            align-items: center;
            margin: 10px;

            > .restPhoto {
                width: 120px;
                height: 80px;
                margin: 10px;
                background-size: cover;
                background-image: url("/assets/no-photo-available.png");
                background-repeat: no-repeat;
                background-position: center;
                border: solid 1px #666666;
                transition: all 300ms;
                cursor: pointer;
                z-index: 0;

                > div {
                    background-size: cover;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    > .rightSide {
        margin-right: 10px;

        h1 {
            font: 32px "Google Sans";
            margin: 0;
            padding: 0;
            color: #cb1517;
        }

        h2 {
            font: 20px "Google Sans";
            color: #cb1517;
        }

        .info {
            font: 16px "Roboto Condensed";
            float: none;

            > span {
                float: right;
            }
        }

        .opis {
            font: 16px "Roboto Condensed";
        }
    }
}

@media screen and (max-width: 800px) {
    .offerDetail {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        .detailsContainer {
            .details {
                display: block;

                .leftSide {
                    width: 80vw;

                    .main {
                        width: 80vw;
                        height: 60vw;

                        .zoom {
                            width: 100%;
                            height: 100%;
                        }

                        .rest {
                            width: 80vw;
                        }
                    }
                }

            }
        }
    }
}

@media screen and (max-width: 480px) {
    .detailsContainer .details .leftSide .main .zoom {
        width: 100%;
        min-height: 60vw;
    }
}
</style>